var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgManager = function SvgManager(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#manager_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    fillRule: "evenodd",
    d: "M5.74 20.326a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm12.245 2.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-7.184 2.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Zm.75-2.25a2.25 2.25 0 1 0 0 4.499 2.25 2.25 0 0 0 0-4.498Zm-.063-14.494a2.53 2.53 0 1 0 0 5.06 2.53 2.53 0 0 0 0-5.06Zm-4.03 2.53a4.03 4.03 0 1 1 8.059 0 4.03 4.03 0 0 1-8.059 0Zm-2.472 9.404a4.248 4.248 0 0 1 4.249-4.249h4.506a4.248 4.248 0 0 1 4.248 4.249v1.03h-1.5v-1.03a2.749 2.749 0 0 0-2.748-2.75h-4.506a2.749 2.749 0 0 0-2.75 2.75v1.03H6.487v-1.03Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "manager_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.984v23.984H0z",
    transform: "translate(.992 .334)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgManager);
export default ForwardRef;